import {getDocumentName} from '../../../utils/document';
import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_INTERNAL_LINK, CONTENT_TYPE_TEXT, CONTENT_CATEGORY_MODEL} from '../../constants';

const DOCUMENT_PATH = `${pathHelpContentFile}fr/FR_MOD_NON_DEC/${getDocumentName('Modele non assurance décennale ok')}.docx`;

export default {
  id: 'MOD_NON_DEC',
  title: 'Un modèle de non assurance à la décennale ? ',
  description: '',
  categories: [CONTENT_CATEGORY_MODEL],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Si vous n’êtes pas assuré en décennale, veuillez prendre le modèle suivant :'
  },
  {
    type: CONTENT_TYPE_INTERNAL_LINK,
    value: DOCUMENT_PATH,
    label: 'Modèle non assurance décennale.'
  }]
};
